if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
    
      

             // ---- CUSTOM MIN & MAX QTY FIX FOR RADIO BUTTONS ----
          if (this.quantityInput) {
            // Get the current variant from Shopify JSON (to correctly load radio when URL has ?variant=...)
            const selectedVariantEl = this.querySelector('script[data-selected-variant]');
            let selectedVariant = null;
            if (selectedVariantEl) {
              try {
                selectedVariant = JSON.parse(selectedVariantEl.textContent);
              } catch (e) {
                console.warn("Cannot parse selected variant JSON", e);
              }
            }

            let min_quantity = 1;
            let max_quantity = -Infinity;

            const radios = this.querySelectorAll('input[type="radio"][custom-quantity-field]');
            let selectedRadio = null;

            // --- Find the radio that corresponds to the currently selected variant ---
            if (selectedVariant) {
              radios.forEach(radio => {
                if (radio.value.includes(selectedVariant.option2)) {
                  selectedRadio = radio;
                }
              });
            }

            // Fallback: if no radio matches variant → use checked radio or first radio
            selectedRadio = selectedRadio || this.querySelector('input[type="radio"][custom-quantity-field]:checked') || radios[0];

            if (selectedRadio) {
              // --- Get min quantity from the selected radio ---
              if (selectedRadio.dataset.min) {
                const parsedMin = parseInt(selectedRadio.dataset.min.trim(), 10);
                if (!isNaN(parsedMin)) min_quantity = parsedMin;
              }
              // --- Get max quantity from the selected radio ---
              if (selectedRadio.dataset.max) {
                const parsedMax = parseInt(selectedRadio.dataset.max.trim(), 10);
                if (!isNaN(parsedMax)) max_quantity = parsedMax;
              }
            }

            // If no max is found, allow unlimited quantity
            if (max_quantity === -Infinity) max_quantity = Infinity;

            // --- Calculate initial quantity value within min and max ---
            let current = parseInt(this.quantityInput.value || "0", 10);
            if (isNaN(current)) current = min_quantity;

            let nextValue = Math.max(min_quantity, current);
            if (max_quantity !== Infinity) nextValue = Math.min(nextValue, max_quantity);

            // --- Set min/max attributes and value on main quantity input ---
            this.quantityInput.setAttribute("min", min_quantity);
            if (max_quantity !== Infinity) this.quantityInput.setAttribute("max", max_quantity);
            else this.quantityInput.removeAttribute("max");
            this.quantityInput.value = nextValue;

            // --- Sync with external quantity input if exists ---
            const externalQty = document.querySelector('quantity-input .quantity__input_n');
            if (externalQty) {
              externalQty.value = nextValue;
              externalQty.setAttribute("min", min_quantity);
              if (max_quantity !== Infinity) externalQty.setAttribute("max", max_quantity);
              else externalQty.removeAttribute("max");

              externalQty.dispatchEvent(new Event("input", { bubbles: true }));
              externalQty.dispatchEvent(new Event("change", { bubbles: true }));
            }

            // Trigger input/change events for main input to recalc prices, stock, etc.
            this.quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
            this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));

            // --- Ensure quantity respects min/max when user types manually (on blur) ---
            this.quantityInput.addEventListener("blur", () => {
              let val = parseInt(this.quantityInput.value || "0", 10);
              if (isNaN(val)) val = min_quantity;
              val = Math.max(min_quantity, val);
              if (max_quantity !== Infinity) val = Math.min(val, max_quantity);
              this.quantityInput.value = val;
            });
          }

          // --- Update quantity when user changes the radio selection ---
          const radios = this.querySelectorAll('input[type="radio"][custom-quantity-field]');
          radios.forEach(radio => {
            radio.addEventListener('change', () => {
              if (this.quantityInput) {
                this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
              }
            });
          });
          // ---- END CUSTOM FIX ----





      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

           this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );
            // ---- CUSTOM MIN & MAX QTY FIX FOR RADIO BUTTONS ----  //
          if (this.quantityInput) {
            // Initialize min and max quantities
            let min_quantity = 1;
            let max_quantity = -Infinity; // start from -Infinity to find the largest max later

            // Get all radio buttons inside the container with custom quantity field
            const radios = this.querySelectorAll('input[type="radio"][custom-quantity-field]');

            radios.forEach(radio => {
              if (!radio.checked) return; // only consider the selected radio

              // --- check min ---
              if (radio.dataset.min) {
                const parsedMin = parseInt(radio.dataset.min.trim(), 10);
                if (!isNaN(parsedMin)) {
                  min_quantity = Math.max(min_quantity, parsedMin); // take the highest min
                }
              }

              // --- check max ---
              if (radio.dataset.max) {
                const parsedMax = parseInt(radio.dataset.max.trim(), 10);
                if (!isNaN(parsedMax)) {
                  max_quantity = Math.max(max_quantity, parsedMax); // take the largest max
                }
              }
            });

            // If no max is found, allow unlimited quantity
            if (max_quantity === -Infinity) max_quantity = Infinity;

            // --- calculate the quantity input value ---
            let current = parseInt(this.quantityInput.value || "0", 10);
            if (isNaN(current)) current = min_quantity; // fallback if user typed invalid number

            let nextValue = Math.max(min_quantity, current); // enforce min
            if (max_quantity !== Infinity) nextValue = Math.min(nextValue, max_quantity); // enforce max

            // --- set quantity input attributes ---
            this.quantityInput.setAttribute("min", min_quantity);
            if (max_quantity !== Infinity) {
              this.quantityInput.setAttribute("max", max_quantity);
            } else {
              this.quantityInput.removeAttribute("max"); // remove max if unlimited
            }
            this.quantityInput.value = nextValue;

            // --- sync with external quantity input if exists ---
            const externalQty = document.querySelector('quantity-input .quantity__input_n');
            if (externalQty) {
              externalQty.setAttribute("min", min_quantity);
              if (max_quantity !== Infinity) {
                externalQty.setAttribute("max", max_quantity);
              } else {
                externalQty.removeAttribute("max");
              }
              externalQty.value = nextValue;

              // trigger input/change events so Shopify/theme scripts recalc correctly
              externalQty.dispatchEvent(new Event("input", { bubbles: true }));
              externalQty.dispatchEvent(new Event("change", { bubbles: true }));
            }

            // --- trigger change for main input to recalc prices, stock, etc. ---
            this.quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
            this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));

            // --- fix value on blur (if user types manually) ---
            this.quantityInput.addEventListener("blur", () => {
              let val = parseInt(this.quantityInput.value || "0", 10);
              if (isNaN(val)) val = min_quantity;
              val = Math.max(min_quantity, val);
              if (max_quantity !== Infinity) val = Math.min(val, max_quantity);
              this.quantityInput.value = val;
            });
          }

          // --- add event listener to update quantity when radio changes ---
          const radios = this.querySelectorAll('input[type="radio"][custom-quantity-field]');
          radios.forEach(radio => {
            radio.addEventListener('change', () => {
              // trigger input event to recalc min/max
              if (this.quantityInput) this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            });
          });

          // ---- CUSTOM MIN & MAX QTY FIX FOR RADIO BUTTONS ----  //






          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
